import React from "react"

interface FileIconProps {
    size: number,
    className?: string
}
export const FileIcon = ({ size = 32, className = "" }: FileIconProps) => {

    return (

        <svg width={size} height={size} viewBox="0 0 512 512"

        >
            <title>ionicons-v5-d</title>
            <path
                className={className}
                d="M216.08,192V335.85a40.08,40.08,0,0,0,80.15,0l.13-188.55a67.94,67.94,0,1,0-135.87,0V337.12a95.51,95.51,0,1,0,191,0V159.74"
                style={{
                    fill: "none",
                    strokeLinecap: "round",
                    strokeMiterlimit: "10",
                    strokeWidth: "32px"
                }} />
        </svg>
    )

} 